(function ($) {
  function MultiSelectModalWindow(inp, opt) {
    this.init(inp, opt);
  }

  MultiSelectModalWindow.prototype = {
    //Input на странице, на который навешивается этот плагин.
    inp: null,
    //Класс компоненты "Выбор из справочника"
    rsInstance: null,

    // html разметка для добавления в модальное окно
    html: null,
    // объект со списком записей и выбранными записями
    dataObject: null,
    // нужна ли колонка с названием группы, к которой принадлежит запись
    withGroupColumn: null,
    // jquery объект таблицы с выбранными записями
    selectedRecordsTable: null,
    // jquery объект списка записей
    recordsList: null,
    // Input фильтра.
    filterInput: null,
    // Спиннер в строке фильтра.
    filterSpinner: null,
    // Сообщение под деревом.
    groupsListMessageBox: null,

    //REVIEW Комментарий
    navigationKeyCodes: [27, 9, 13, 37, 38, 39, 40],
    // Предыдущее значение фильтра.
    lastFilterValue: "",


    /* Переопределяемые параметры */
    defaultRecordIconClass: "user-tree__icon_default",
    defaultMarkedRecordIconClass: "user-tree__icon_selected-default",
    // Группы, в которых не будет осуществляться поиск.
    excludeGroups: [],
    customPlaceholder: null,
    // Дерево пользователей.
    treeMode: false,
    treeUrl: "/UserList.asmx/GetUsers?isrightslist=false",
    treeModeRecordIconClass: "user-tree__icon_user",
    treeModeGroupIconClass: "user-tree__icon_group",
    treeModeMarkedRecordIconClass: "user-tree__icon_selected-user",
    treeModeMarkedGroupIconClass: "user-tree__icon_selected-group",
    favoriteUserIconClass: "user-tree__icon_fav-user",
    favoriteUserGroupIconClass: "user-tree__icon_fav-group",
    recordsListContextMenu: null,
    // нужно ли показывать окно по нажатию на [...]
    bindWindowOnInput: true,


    // Список выполняющихся запросов, что была возможно их досрочно прекратить.
    _lastRequests: [],
    // Для небольшой задержки при вводе фильтра, что бы не отправлять слишком много запросов.
    _filterTimeout: null,
    // Отображены не все записи?.
    _isNotAllRecordsShown: false,


    //Список навешенных событий.
    events: null,
    // Привязка к событиям
    bind: function (name, func) {
      var me = this;
      if (me.events != null) {
        me.events[name] = func;
      }
    },
    // Создание событий
    fire: function (name) {
      var me = this;
      if (me.events != null && typeof me.events[name] !== 'undefined') {
        var r = me.events[name].apply(me, arguments);
        return (typeof r === 'undefined' || r);
      }
    },


    // Инициализация объекта.
    init: function (inp, opt) {
      var me = this;

      me.events = {};
      //По-умолчанию нужно показывать окно по нажатию на [...]
      me.bindWindowOnInput = true;
      //Вначале не нужно показывать сообщение что показы не все записи.
      me._isNotAllRecordsShown = false;

      // Переозначиваем параметры.
      if (opt) { $.extend(me, opt); };

      // Инициализируем объект с данными.
      me.dataObject = {
        groups: {},
        selectedItems: [],
      };

      if (inp) {
        me.inp = inp;
        me.rsInstance = inp.data('ReferenceSelectInstance');
        if (!!me.rsInstance) {
          me.bindThis();
        }
      }
    },

    // Навешивает события на открытие модального окна.
    bindThis: function () {
      var me = this, rs = me.rsInstance;

      // Переопределим функцию замены выбранного элемента на что-то другое.
      me.inp.off('ReplaceSelectedItem').on('ReplaceSelectedItem.MultiSelectModalWindow', function (e, oldID, newValues) {
        if (me.isModalShown()) {
          var convNewValues = [];
          for (var i = 0, len = newValues.length; i < len; i++) {
            convNewValues.push(me.convertRefSelectItemToThis(newValues[i]));
          };
          me.replaceSelectedItem(me.convertRefSelectItemIdToThisId(oldID), convNewValues);
        } else {
          rs.replaceSelectedItem(oldID, newValues);
        };
      });

      try {
        if (me.bindWindowOnInput) {
          rs.img.addClass('MultiselectModalWindowIco').off('click touchstart').on('click.MultiSelectModalWindow touchstart.MultiSelectModalWindow', function () {
            me.show();
          });
        }
        else {
          rs.img.removeClass('MultiselectModalWindowIco');
        }
      } catch (e) {
        // Всякое бывает.
      }
    },

    // Конвертирует ИД выбранного элемента обычного выбора из справочника в ИД выбранного элемента модального диалога.
    convertRefSelectItemIdToThisId: function (itemId) {
      var me = this, rs = me.rsInstance;

      var groupcode,
          id = itemId,
          idParts = id.split(':');

      if (idParts.length == 2) {
        groupcode = idParts[0];
        id = idParts[1];
      } else {
        groupcode = rs.getFirstRefCode();
      };

      return {
        id: id,
        groupcode: groupcode
      };
    },

    // Конвертирует выбранный элемент обычного выбора из справочника в выбранный элемент модального диалога.
    convertRefSelectItemToThis: function (item) {
      var res = this.convertRefSelectItemIdToThisId(item[0]);
      res['name'] = (res.id > 0 ? item[2] : item[1]);
      return res;
    },

    // Открыто ли модальное окно.
    isModalShown: function () {
      return this.recordsList != null && this.recordsList.is(':visible');
    },

    // Получение записей всех справочников.
    getData: function (q, OnSuccess, OnError) {
      var me = this;
      var rs = me.rsInstance;
      // Показывает спиннер вместо иконки с тремя точками.
      me.showSpinner();

      // Запоминаем фильтр для которого сделали запрос.
      me.lastFilterValue = q;

      if (me.treeMode) {
        me.requestTree('', q);
      }
      else {
        me.sendRequests(q).done(function () {
          me.hideSpinner();
          if (OnSuccess) OnSuccess();
        }).fail(function () {
          // Скрывает спиннер вместо иконки с тремя точками.
          rs.hideSpinner();
          if (OnError) OnError();
        });
      }
    },
    // Отправляет запросы на сервер для каждого справочника.
    sendRequests: function (q) {
      var me = this, rs = me.rsInstance;
      var requests = [];

      // Прекращаем все предыдущие запросы.
      while (me._lastRequests.length > 0) {
        me._lastRequests.pop().abort();
      }

      // Обновляем результаты фильтрации.
      me.fillAvailableGroups();

      // Для пустого запроса не загружаем все справочники, а подгружаем их только при нажатии на стрелочку. Если 1 справочник, то загружаем.
      if (!q && Object.keys(me.dataObject.groups).length > 1) {
        // Сразу же завершаем запросы, т.к. подгрузка значение осуществляется после нажатия на стрелочку.
        return $.when();
      }

      // Получаем записи всех справочников.
      for (var groupcode in me.dataObject.groups) {
        if (groupcode !== 'length') { //Нужно ли исключить группу из обратки.
          requests.push(me.sendRequest(q, groupcode));
        };
      };
      me._lastRequests = $.merge(me._lastRequests, requests);

      // Возвращаем $.Deferred объект что бы дождаться завершения всех запросов и только потом открыть модальное окно.
      return $.when.apply(this, requests);
    },
    // Отправляет запрос на сервер для одного справочника.
    sendRequest: function (q, groupcode, OnSuccess, OnError) {
      var me = this, rs = me.rsInstance;
      var OnSuccessFunc = function (status, data) {
        me.onSuccessGetData(groupcode, status, data);
        // Признак загруженности записей в группе.
        me.dataObject.groups[groupcode].isLoaded = true;
        if (OnSuccess) OnSuccess();
      };
      var OnErrorFunc = function (msg, isHttp) {
        me.onErrorGetData(groupcode, msg, isHttp);
        // Признак загруженности записей в группе.
        me.dataObject.groups[groupcode].isLoaded = true;
        if (OnError) OnError();
      };
      var limit = (MULTI_SELECT_RECORD_COUNT === -1 ? 300 : MULTI_SELECT_RECORD_COUNT + 1); // Загружаем +1 запись, что бы потом выдать сообщение "Показаны не все".
      return rs.sendQuery(groupcode, q, 1, limit, OnSuccessFunc, OnErrorFunc);
    },
    //Успешное получение записей одного справочника.
    onSuccessGetData(refcode, status, rows) {
      if (rows.length) {
        for (let row of rows) {
          // Иногда может прийти в виде ПОЛ_123123
          let refCode;
          let id = row.id;
          if (row.id.includes('_')) {
            [refCode, id] = row.id.split('_');
          }

          this.dataObject.groups[refcode].items.push({
            id,
            name: row.encodedTitle,
            refCode,
          });

          // Если уже достигли ограничения, а еще остались, то отображаем сообщение "Показаны не все".
          if (Object.keys(this.dataObject.groups[refcode].items).length === MULTI_SELECT_RECORD_COUNT && rows.length >= MULTI_SELECT_RECORD_COUNT) {
            this._isNotAllRecordsShown = true;
            break;
          }
        }
      }
    },
    //Неуспешное получение записей одного справочника.
    onErrorGetData: function (refcode, msg, isHttp) {
      var me = this;
      // Если там ошибка и она не тот что записей не найдено, сохраним её для вывода в шапке.
      if (msg !== L('NO_RECORDS_FOUND')) {
        // В некоторых случаях нужно отображать разные сообщения в заголовке и при раскрытии.
        me.dataObject.groups[refcode].error = msg.split('^')[0];
      };
    },

    //Возвращает индекс найденного элемента по ИД.
    findSelectedItemById: function (id) {
      var me = this,
          selItems = me.dataObject.selectedItems;
      for (var i = 0, len = selItems.length; i < len; i++) {
        if (selItems[i].id === id) {
          return i;
        };
      };
      return -1;
    },

    // Показывает спиннер.
    showSpinner: function () {
      var me = this, rs = me.rsInstance;
      // Показывает спиннер в строке фильтра.
      if (me.filterSpinner) me.filterSpinner.addClass('processing');
      // Показывает спиннер вместо иконки с тремя точками.
      if (rs) rs.showSpinner();
    },
    // Скрывает спиннер.
    hideSpinner: function () {
      var me = this, rs = me.rsInstance;
      // Скрывает спиннер в строке фильтра.
      if (me.filterSpinner) me.filterSpinner.removeClass('processing');
      // Скрывает спиннер вместо иконки с тремя точками.
      if (rs) rs.hideSpinner();
    },

    showModalWindow: function () {
      var me = this, rs = me.rsInstance;

      // если группа только одна то не отображаем ее заголовок в списке и в таблице нет колонки с названиями групп
      me.withGroupColumn = Object.keys(me.dataObject.groups).length > 1;
      me.html = me.buildHtml();
      if (me.html) {
        var dialog = new WA.CMP.dialogs.BaseDialog({
          title: (rs ? rs.Label : ''),
          html: me.html,
          okText: L("OK"),
          cancelText: L("CANCEL"),
          dialogClass: 'stat_MultiselectModalWindow',
          width: 890,
          height: 500,
          isShowCancelButton: !rs.isReadonly(),
          onClose: function () {
            if (WA.ENV.isAndroid()) {
              rs.inp.removeAttr('disabled');
              $('.fakeInput').removeAttr('disabled');
            }
            me.hideContextMenu();
            key.setScope('common');
          },
          ok: function () {
            //OK
            me.save();
          }, cancel: function () { /* Cancel */ }
        });
        dialog.show();

        key.setScope('modalwindow');
        me._InitInternalObjects();
        me.fillItemsList();
        me.fillSelectedItemsTable();
        me._InitEvents();
        me._fixSelectedItemsTableBorder();
        me._adjustModalWindowIfSmallScreen();
        me._disableRefSelectInputIfAndroid();

        // Событие "После открытия окна".
        me.fire('OnAfterOpen');
      }
    },

    hideContextMenu: function () {
      $('#mainContextMenuContainer').css('visibility', 'hidden');
    },

    // Заполняет список доступных групп.
    fillAvailableGroups: function () {
      var me = this, rs = me.rsInstance;
      me.dataObject.groups = {};
      // Получаем записи всех справочников.
      var i = 0;
      for (var refcode in rs.refcodes) {
        if ($.inArray(refcode, me.excludeGroups) === -1) { //Нужно ли исключить группу из обратки.
          // Пока записей нет.
          me.dataObject.groups[refcode] = {
            groupname: me.rsInstance.refcodes[refcode].Caption,
            isLoaded: false,
            items: []
          };
          i++;
        }
      }
    },

    show: function () {
      var me = this, rs = me.rsInstance;
      // Получаем выбранные элементы.
      me.dataObject.selectedItems = rs.getValues();
      // Заполняем список доступных групп.
      me.fillAvailableGroups();
      // Получаем дерево без фильтра.
      me.getData('', function () {
        me.showModalWindow();
      });
    },

    // Сохраняет выбранные элементы в скрытом поле выбора из справочника.
    save: function () {
      var me = this, rs = me.rsInstance;
      // Сохранение в режиме "только для чтения" не работает.
      if (!rs.isReadonly()) {
        rs.setValues(me.dataObject.selectedItems, true);
        me.inp.trigger('change');
      }
    },

    /*--------------------------------------------*/


    /* Построение html по полученному объекту */

    buildHtml: function () {
      var me = this;
      var html = me.buildLeftArea();
      html += me.buildSelectedRecords();
      return html;
    },

    buildSelectedRecords: function () {
      var html = '<div id="SelectedRecords" class="stat_SelectedRecords"><div class="area-label">' + L('SELECTED_RECORDS') + ':</div>';
      html += '<div id="selectedRecordsScrollArea">';
      html += this.buildSelectedItemsTable();
      html += '</div></div>';
      return html;
    },

    buildSelectedItemsTable: function () {
      var me = this, rs = me.rsInstance;
      var html = '<table cellspacing="0" id="selectedRecordsTable" class=""><thead><tr>';
      // Не добавляем колонку для удаления записи, если только для чтения.
      if (!rs.isReadonly()) {
        html += '<th class="selectedRecordsHeader emptyHeader"></th>';
      }
      html += '<th class="selectedRecordsHeader ' + (me.withGroupColumn ? 'itemNameCol' : 'singleCol') + '">' + L('NAME') + '</th>';
      if (me.withGroupColumn) {
        html += '<th class="itemGroupCol selectedRecordsHeader">' + L('REFERENCE') + '</th>';
      }
      html += '</tr></thead></table>';
      return html;
    },

    fillSelectedItemsTable: function () {
      var me = this,
          html = "";
      var selItems = me.dataObject.selectedItems;
      for (var i = 0, len = selItems.length; i < len; i++) {
        html += this.buildSelectedItemsTableRow(selItems[i]);
      }
      me.selectedRecordsTable.append(html);
    },

    //REVIEW Название не говорящее.
    buildSelectedItemsTableRow: function (selectedItem) {
      var me = this, rs = me.rsInstance;
      var html = '<tr id="' + selectedItem.id + '">';
      // Не добавляем колонку для удаления записи, если только для чтения.
      if (!rs.isReadonly()) {
        html += '<td><p data-name="DeleteSelectedIcon" class="removeFromSelect" title="' + L("DELETE") + '"><svg class="user-tree__delete-icon"><use xmlns:xlink="http://www.w3.org/1999/xlink" xlink:href="#close-delete-16"></use></svg></p></td>';
      }
      // Получить представление справочника
      var controlId = me.inp.attr('id');
      var requisite = WA.CR.form.getRequisiteByControlId(controlId);

      var viewNameParam = "";
      if (requisite) {
        var referenceViewName = requisite.referenceViewName();
        if (referenceViewName) viewNameParam = "&refview=" + encodeURI(referenceViewName);
      }

      // Нужно ли отображать подсказку.
      const href = `/Reference.aspx?sys=${g_SysCode}&ext=${g_ExtName}&compcode=${encodeURI(selectedItem.groupcode)}${viewNameParam}&id=${selectedItem.id}`;
      const link = `<a href="${href}" target="_blank" data-name="ItemLink" >`;
      var hintData = rs.getHintData(selectedItem.groupcode, selectedItem.id, selectedItem.name);
      html += '<td class=" ' + (me.withGroupColumn ? 'itemNameCol' : 'singleCol') + '"><div class="' + hintData["class"] + '" id="' + selectedItem.id + '" ' + hintData['attr'] + ' >' + link + ('' + selectedItem.name).escapeHtml() + '</a></div></td>';
      if (me.withGroupColumn) {
        html += '<td class="itemGroupCol"><div>' + (me.dataObject.groups[selectedItem.groupcode] ? link + me.dataObject.groups[selectedItem.groupcode].groupname + '</a>' : '') + '</div></td>';
      }
      html += '</tr>';
      return html;
    },

    buildLeftArea: function () {
      var me = this, rs = me.rsInstance;
      var tooltip = this._BuildPlaceholderString();
      var html = '<div class="stat_AvailableRecords leftarea ' + (rs.isReadonly() ? 'readonly' : '') + '">';
      html += '<div class="area-label">' + L('ALL_RECORDS') + ':</div>';

      var filterDisabledAttr = !rs.isReadonly() ? '' : 'disabled="disabled" readonly="readonly" ';
      //Шамов А.: Для единообразия убрал placeholder, что бы крутые браузеры не отображали его.
      html += '<div class="group-list-filter-container"><input type="text" id="filterInput" class="input" placeholder="' + tooltip + '" title="' + tooltip + '" ' + filterDisabledAttr + ' /><p></p></div>';

      html += '<div id="recordsList" class="user-tree"><div class="groupsListMessageBox"></div></div>';
      html += '</div>';
      return html;
    },

    fillItemsList() {
      let html = '';

      if (this._isNotAllRecordsShown) {
        this.showGroupsListMessage(L('NOT_ALL_RECORDS_SHOWN'));
      } else {
        this.hideGroupsListMessage();
      }

      let groupNames = Object.keys(this.dataObject.groups);
      if (groupNames.length === 1) {
        for (let groupName of groupNames) {
          html += this.buildItemsList(groupName, this.dataObject.groups[groupName]);
        }
      } else if (groupNames.length) {
        html += this.buildGroupsList(this.dataObject.groups);
      }

      if (html) {
        this._updateRecordsList(html);
      } else {
        this.showInfoInGroupsList(this._isFilterEmpty() ? L('ENTER_FILTER_VALUE') : L('EMPTY_WITH_FILTER'));
      }

      this.MarkSelectedRecordsInList();
      this.recordsList.scrollTop(0);
    },

    buildGroupsList: function (groups) {
      var me = this;
      var html = "";

      for (var groupcode in groups) {
        // Не отображаем справочники, в которых не нашли записей, но отображаем если была какая-то ошибка.
        if (groupcode != "length" && (!groups[groupcode].isLoaded || groups[groupcode].items.length > 0 || typeof groups[groupcode].error !== 'undefined')) {
          html += me.buildSingleGroup(groups[groupcode], groupcode);
        }
      }
      return html;
    },

    buildSingleGroup: function (group, key) {
      var me = this;
      var html = "";
      html += '<div data-name="Item" compcode="' + key + '" class="recordGroup ' + (group.isLoaded ? '' : 'hiddengroup') + '">' +
            '<span><p class="' + (group.isLoaded ? 'openedgroup' : 'closedgroup') + '"></p><div><svg class="multiselect__icon"><use xmlns:xlink="http://www.w3.org/1999/xlink" xlink:href="#reference-16"></use></svg>' + group.groupname + '</div></span>';
      html += me.buildItemsList(key, group);
      html += '</div>';
      return html;
    },

    //REVIEW Название не говорящее -какие ItemsList? в дереве или таблице?.
    buildItemsList: function (groupcode, group) {
      var me = this, rs = me.rsInstance;
      var items = group.items;
      var html = "";

      if (items.length == 0 && typeof (group.error) != 'undefined') {
        g_group = group;
        var record = { id: -1, name: group.error };
        var text = record.name;
        var item = '<div class="errormsg" title="' + text + '">' + text + '</div>';
        html += item;
        return html;
      }

      for (var j = 0; j < items.length; j++) {
        if (items[j].groupname) {
          html += this.buildSingleGroup(items[j], items[j].compcode);
        }
        else {
          var record = items[j];
          // ИД могут быть отрицательные - это информационные сообшения для определенного справочника.
          if (record.id > 0) {
            // Нужно ли отображать подсказку.
            var recordName = record.name.indexOf('<p class="') > -1 ? record.name.substr(record.name.indexOf('</p>') + 4) : record.name;
            var hintData = rs.getHintData(groupcode, "" + record.id, recordName);
            var text = '<div class="' + hintData["class"] + '" ' + hintData['attr'] + '><p class="ico ' + this.defaultRecordIconClass + '"></p>' + recordName + '</div>';
            var item = '<div id="' + record.id + '" class="item" data-name="Item"><span>' + text +
              '<p data-name="ArrowRight" class="treeview_img_action user-tree__add" style="visibility:hidden;"title="">' +
              '<svg class="user-tree__add-icon"><use xmlns:xlink="http://www.w3.org/1999/xlink" xlink:href="#chooseRecord-16"></use></svg>' +
              '</p></span></div>';
            html += item;
          } else {
            //Отобразим информационное сообщение.
            me.showGroupsListMessage(record.name);
          };
        };
      };

      return html;
    },

    //Отображает сообщение в центре дерева групп.
    showInfoInGroupsList: function (msg) {
      var me = this;
      var container = me.recordsList.data('iscroll') ? me.recordsList.find('#records_scroller') : me.recordsList;
      container.html('<div class="empty-with-filter">' + msg + '</div>');
    },

    requestTree: function (folder, filter) {
      var me = this, rs = me.rsInstance;
      var folderId = folder === '' ? folder : folder.attr('id');
      return CallService(me.treeUrl,
        { ObjectID: "-1", ObjectType: "-1", FolderID: "" + folderId, Filtrator: "" + filter },
        function (res) {
          if (res.Success) {
            // Получаем названия всех справочников.
            for (var refcode in rs.refcodes) {
              if ($.inArray(refcode, me.excludeGroups) === -1) { //Нужно ли исключить группу из обратки.
                me.dataObject.groups[refcode] = {
                  groupname: me.rsInstance.refcodes[refcode].Caption,
                  items: []
                };
              }
            }

            //Данные получены, открываем модальное окно, что бы создались нужные div
            if (!me.isModalShown()) me.showModalWindow();
            me.hideSpinner();
            //Скроем информационное сообщение.
            me.hideGroupsListMessage();
            if (folder.length) {
              //Подгруппа.
              var html = me.fillTree(res.Result);
              //var group = me.recordsList.find('#' + folderID);
              folder.find('.waiting').remove(); // убираем спинер
              me._InitRecordsListEvents(folder.append(html), true);
            }
            else {
              if (res.Result.length > 0) {
                me._updateRecordsList(me.fillTree(res.Result));
                me._InitRecordsListEvents();
                if (res.Result.length == 1 && res.Result[0].id == 0 && res.Result[0].isGroup && res.Result[0].children.length == 0) {
                  me.showGroupsListMessage(L("ADD_USER_TO_FAVORITES_WITH_RIGHT_CLICK"));
                }
              } else {//Если результата нет, то значит скрыта орг.структура.
                //Невозможно просмотреть дерево пользователей. Воспользуйтесь поиском по имени пользователя или группы.
                me.showInfoInGroupsList(me._isFilterEmpty() ? L("RIGHTS_SHOWING_TREE_ERROR") : L('EMPTY_WITH_FILTER'));
              };
            };
            me.MarkSelectedRecordsInList();
          };
        },
        function () { me.hideSpinner(); });
    },

    _updateRecordsList: function (html) {
      var me = this;
      // Оставляем div с сообщением. если активен сколлинг, то убираем внутри контейнера для скрола
      var container = me.recordsList.data('iscroll') ? me.recordsList.find('#records_scroller') : me.recordsList;
      container.children('div:not(.groupsListMessageBox)').remove();
      // Добавляем в начало новые данные.
      container.prepend(html);
    },

    fillTree: function (nodes) {
      var html = "";
      for (var i = 0; i < nodes.length; i++) {
        if (nodes[i].id >= 0) {
          html += this.buildTreeNodeHTML(nodes[i]);
        } else {
          this.showGroupsListMessage(nodes[i].text);
        }
      }
      return html;
    },

    buildTreeNodeHTML: function (node) {
      var html = node.text;
      if (node.children.length > 0) {
        html = $(html).append(this.fillTree(node.children));
        return html[0].outerHTML;
      }
      return html;
    },

    // Отображает сообщение под деревом.
    showGroupsListMessage: function (msg) {
      var me = this;
      var msgBox = me.recordsList.find('.groupsListMessageBox');
      if (msgBox.length == 0) {
        msgBox = me.groupsListMessageBox.clone();
        me.recordsList.append(msgBox);
      };
      msgBox.text(msg).show();
    },
    // Скрывает сообщение под деревом.
    hideGroupsListMessage: function () {
      var me = this;
      me.recordsList.find('.groupsListMessageBox').text('').hide();
    },

    /* ---------------------------------- */

    /* Инициализация объектов и событий */

    _InitInternalObjects: function () {
      var me = this;
      me.selectedRecordsTable = $('#selectedRecordsScrollArea').children('table');
      me.recordsList = $('#recordsList');
      me.groupsListMessageBox = $('.groupsListMessageBox', me.recordsList);
      me.filterInput = $('#filterInput');
      //if ($.ipad && !WA.ENV.isAndroid()) me.filterInput.css('width', '100%');
      me.filterSpinner = me.filterInput.find('p');
    },

    _isFilterEmpty: function () {
      return this.filterInput.val().replace(/ /g, "") === '';
    },

    _InitScrollForTouchScreens: function () {
      if ($.scrollActive) {
        if (this.recordsList.data('iscroll')) {
          //logDebug('refreshScroll');
          this.recordsList.data('iscroll').refresh();
          // вычитается 20 пикселей чтобы последний элемент в списке было видно при прокрутке
          this.recordsList.data('iscroll').maxScrollY -= 20;
        } else {
          //logDebug('initScroll');
          this.recordsList.children().wrapAll('<div id="records_scroller" style="width:500px;">');
          var recordsListScroll = new iScroll('recordsList', { useTransform: true });
          // вычитается 20 пикселей чтобы последний элемент в списке было видно при прокрутке
          recordsListScroll.maxScrollY -= 20;
          this.recordsList.data('iscroll', recordsListScroll);
        }
      }
    },

    _InitEvents: function () {
      var me = this;
      if (me.html != null) {
        me._InitSelectedRecordsEvents();
        me._InitLeftAreaEvents();
      }
    },

    _InitLeftAreaEvents: function () {
      this._InitRecordsListEvents();
      this._InitFilterInputEvents();
    },

    _InitRecordsListEvents: function (block, isNeedProcessChild) {
      var me = this, rs = me.rsInstance;
      var HoverItem = function () { me.HoverItem(this); };
      var UnhoverItem = function () { me.UnhoverItem(this); };

      var items = $([]); // = block ? block.find('div.item') : me.recordsList.find('div.item');
      if (block) {
        if (isNeedProcessChild) {
          items = block.find('div.item');
        } else {
          if (block.hasClass('item')) items = block;
        }
      } else {
        items = me.recordsList.find('div.item');
      }

      // Если только на чтение, то запрещаем выбирать записи.
      if (!rs.isReadonly()) {
        items.find('span > div, p[data-name="ArrowRight"]').off('click.MultiSelectModalWindow').on('click.MultiSelectModalWindow', function (ev) {
          me.SelectItem($(this).parent().parent());
        });

        var groups = $(); // = block ? block.find('.recordGroup > span') : me.recordsList.find('.recordGroup > span');
        if (block) {
          if (isNeedProcessChild) {
            groups = block.find('.recordGroup > span');
          } else {
            if (block.hasClass('recordGroup')) groups = block.children('span');
          }
        } else {
          groups = me.recordsList.find('.recordGroup > span');
        }
        if (me.treeMode) {
          groups.find('p:first').off('click.MultiSelectModalWindow').on('click.MultiSelectModalWindow', function () {
            me.ShowHideRecordsGroup($(this).parent());
          });

          me._InitItemsListContextMenu(groups.not('#0'));
          me._InitItemsListContextMenu(items);
          // Если только на чтение, то запрещаем выбирать группы в дереве.
          groups.find('div, p[data-name="ArrowRight"]').off('click.MultiSelectModalWindow').on('click.MultiSelectModalWindow', function () {
            me.SelectItem($(this).parent().parent());
          });
        } else {
          groups.off('click.MultiSelectModalWindow').on('click.MultiSelectModalWindow', function () {
            me.ShowHideRecordsGroup(this);
          });
        }
        if (!$.ipad && !WA.ENV.isAndroid()) { // для айпада отключаем ховеры
          items.hover(HoverItem, UnhoverItem);
          groups.hover(function () { me.HoverGroup($(this).parent()); }, function () { me.UnhoverGroup($(this).parent()); });
        }

        //REVIEW Может это в ветке else сделать?
        me._InitScrollForTouchScreens();
      }

      // Навешивает события для отображения подсказок.
      me._initHintEvents(items);
    },

    // добавляет кнопочку для контекстного меню на планшетах и навешивает клик
    _InitItemsListContextMenu: function (items) {
      var me = this;
      var favoritesGroup = $('#0');
      var ShowContextMenu = function (e, currObj) {
        e.preventDefault();
        e.stopPropagation();

        var pos = { x: e.pageX, y: e.pageY };
        if (currObj) {
          //для планшетов
          pos.x = currObj.offset().left;
          pos.y = currObj.offset().top + 50; //смещаем что бы было видно элемент, для которого вызвали меню.
        };

        currObj = currObj ? currObj : $(this);
        if (!currObj.attr('id')) currObj = currObj.parent();
        var menu = me._GetContextMenu(currObj, favoritesGroup);
        menu.showAt({ 'left': pos.x, 'top': pos.y });
      };
      var ShowContextMenuTablet = function (e) {
        var a = $(this).parent().parent().parent();
        ShowContextMenu(e, a);
      };

      if (!$.ipad && !WA.ENV.isAndroid()) {
        items.bind('contextmenu', ShowContextMenu);
        favoritesGroup.children('span').unbind('contextmenu');
      } else { // для планшетов
        var contextMenuBtn = items.find('.tabletcontextm');
        if (contextMenuBtn.length > 0) {
          contextMenuBtn.off('touchstart.multiselect').on('touchstart.multiselect', ShowContextMenuTablet);
        } else {
          var contextmenuButton = '<svg class="user-tree__menu-icon"><use xmlns:xlink="http://www.w3.org/1999/xlink" xlink:href="#hamburger-20"></use></svg>';
          items.find('p.ico').before(contextmenuButton).prev().off('touchstart.multiselect').on('touchstart.multiselect', ShowContextMenuTablet);
        }
        favoritesGroup.children('span').find('.tabletcontextm').off('touchstart.multiselect').remove();
      }
    },

    _InitSelectedRecordsEvents: function () {
      var me = this, rs = me.rsInstance;

      var cols = [];

      // Колонка для удаления выбранной записи.
      if (!rs.isReadonly()) {
        var colWidth = $.ipad || WA.ENV.isAndroid() || WA.ENV.browser.name.toLowerCase() == 'safari' ? '35px' : '15px';
        cols.push({ "sWidth": colWidth, "bVisible": true, "bSortable": false });
      }

      // Колонка "Наименование"
      var colWidth = me.withGroupColumn ? '300px' : '400px';
      cols.push({ "bVisible": true, "sWidth": colWidth, "bSortable": false });

      // Колонка "Справочник"
      if (me.withGroupColumn) {
        cols.push({ "bVisible": true, "bSortable": false });
      }

      me.selectedRecordsTable.dataTable({
        "sScrollY": (me.selectedRecordsTable.parent().height() - 33) + 'px',
        "sScrollX": "100%",
        "bAutoWidth": false,
        "bDeferRender": true,
        "bPaginate": false,
        "bSortable": false,
        "oLanguage": { "sZeroRecords": L("EMPTY") },
        'aoColumns': cols
      });
      var tableWidth;
      if (!$.ipad) {
        tableWidth = '100%';
      }
      if (WA.ENV.isAndroid()) tableWidth = 489; // хаки чтобы таблица не прокручивалась по горизонтали
      me.selectedRecordsTable.css('width',tableWidth); // просто через width в Firefox и IE ширина некорректно устанавливалась (v5.5)
      me.selectedRecordsTable.find('th:last-child').width('auto');
      me.selectedRecordsTable.parent().width(tableWidth).attr('id', 'selectedRecordsWrapper');
      $('.dataTables_scrollHeadInner').width(tableWidth)
        .children('table').css('width',tableWidth)
        .find('th:last-child').width('auto');
      me.selectedRecordsTable.find('tr').each(function () { me._InitSingleSelectedRecordEvents(this); });
    },

    _InitSingleSelectedRecordEvents(row) {
      let rs = this.rsInstance;
      row = $(row);

      if(!$.ipad && !WA.ENV.isAndroid()) {
        row.hover(
          () => row.addClass('over').find('.removeFromSelect').css('visibility', 'visible'),
          () => row.removeClass('over').find('.removeFromSelect').css('visibility', 'hidden')
        );
      }
      else {
        row.find('.removeFromSelect').css('visibility', 'visible');
      }
      row.find('.removeFromSelect').on('click.MultiSelectModalWindow', this, function (e) {
        e.data.DeleteItemFromSelection(this);
      });

      // Навешивает события для отображения подсказок.
      this._initHintEvents(row);
    },

    // Навешивает события для отображения подсказок.
    _initHintEvents: function (el) {
      if (!$.ipad && !WA.ENV.isAndroid()) {
        el.find('.hint').each(function () {
          InitAdditionalInfoTooltip($(this));
        });
      };
    },

    // Навешивает события на поле фильтрации
    _InitFilterInputEvents: function () {
      var me = this;
      var eventName = 'keydown';
      //if ($.browser.mozilla) eventName = 'keypress'; убрали так как шифт+таб не работал нормально
      me.filterInput.on(eventName + '.MultiSelectModalWindow blur.MultiSelectModalWindow', me, me._KeyPressEventHandler);
      me._InitKeyNavigation();
    },

    _KeyPressEventHandler: function (ev) {
      var me = ev.data;
      if ($.inArray(ev.keyCode, me.navigationKeyCodes) > -1) {
        if (ev.keyCode == 9) {
          $(this).blur();
          var firstItem = me.recordsList.find('div:first');
          firstItem.hasClass('item') ? me.HoverItem(firstItem) : me.HoverGroup(firstItem);
          me.recordsList.scrollTop(0);
          return false;
        }
        //me._NavigationKeyPressHandler(ev);
      } else {
        me.MakeFilterRequest();
      }
    },

    _InitKeyNavigation: function () {
      var me = this, rs = me.rsInstance;
      if (!rs.isReadonly()) {
        if (!me.rsInstance.inp.hasClass('modalWindowKeyNavigationActive')) {
          var scope = 'modalwindow';
          key('down', scope, function () { me.upDownKeyNavigation(true); return false; });
          key('up', scope, function () { me.upDownKeyNavigation(false); return false; });
          key('right', scope, function () { me.RightArrowKeyPress(); return false; });
          key('left', scope, function () { me.LeftArrowKeyPress(); return false; });
          key('delete', scope, function () { me.DeleteKeyPress(); return false; });
          key('shift+tab', scope, function () {
            me.filterInput.focus();
            me.UnhoverItem(me.recordsList.find('.over'));
            me.UnhoverGroup(me.recordsList.find('.groupOver'));
            return false;
          });
          var selector = '.item.over';
          if (this.treeMode) { selector += ',.recordGroup.groupOver'; }
          key('enter', scope, function () {
            var item = me.recordsList.find(selector).first();
            if (item.length) me.SelectItem(item); return false;
          });
          key.setScope(scope);
          me.rsInstance.inp.addClass('modalWindowKeyNavigationActive');
        }
      }
    },

    _BuildPlaceholderString: function () {
      var me = this;
      if (me.customPlaceholder === null) {
        let str = (Object.keys(me.dataObject.groups).length === 1 ? L('MULTI_SEARCH_IN_REFERENCE') : L('MULTI_SEARCH_IN_REFERENCES'));
        var i = 0;
        var names = [];
        for (var key in me.dataObject.groups) {
          if (key != 'length') {
            names[i] = '&quot;' + me.dataObject.groups[key].groupname + '&quot;';
            i++;
          }
        }
        str += names.join(', ');
        return str;
      } else {
        return me.customPlaceholder;
      }
    },

    // Строит контекстное меню в зависимости от элемента
    _GetContextMenu: function (item, favoritesGroup) {
      var menuItems = [];
      var addMenuItemText;
      var addClickHandler;
      var favoritesMenuItemText;
      var favoritesClickHandler;
      var favoritesIcon;
      var actionIcon;
      var itemID = item.attr('id');
      var me = this;

      if (favoritesGroup.children('#' + itemID).length > 0 || item.hasClass('favorite')) {
        favoritesMenuItemText = L("REMOVE_FROM_FAVORITES");
        favoritesClickHandler = function () {
          me.addOrRemoveFavorites(item, itemID, false, favoritesGroup);
        };
        favoritesIcon = "deleteFromFavourites-16";
      } else {
        favoritesMenuItemText = L("ADD_TO_FAVORITES");
        favoritesClickHandler = function () {
          me.addOrRemoveFavorites(item, itemID, true, favoritesGroup);
        };
        favoritesIcon = "folderFavorites-16";
      }
      if (me.findSelectedItemById(itemID) !== -1) {
        // то элемент уже выбран
        addMenuItemText = L("USERGROUP_EXCLUDE");
        addClickHandler = function () {
          me.selectedRecordsTable.find('tr#' + itemID).find('p:first').click();
        };
        actionIcon = "unchooseRecord-16";
      } else {
        addMenuItemText = L("USERGROUP_INCLUDE");
        addClickHandler = function () {
          me.SelectItem(item);
        };
        actionIcon = "chooseRecord-16";
      }

      menuItems.push({ text: addMenuItemText, onClick: addClickHandler, icon: actionIcon, name: 'addMenuItem' });
      menuItems.push({ text: favoritesMenuItemText, onClick: favoritesClickHandler, icon: favoritesIcon, name: 'favoritesMenuItem' });

      return new ContextMenu(menuItems, { width: "auto", targetElement: item });
    },

    // Добавление или удаление пользователей из избранного
    // item - элемент, который надо добавить
    // needToAdd - нужно ли добавить или удалить
    addOrRemoveFavorites: function (item, itemId, needToAdd, favoritesGroup) {
      var me = this;
      CallService("/UserList.asmx/AddOrRemoveFavorites", { PrincipalID: itemId, IsGroup: item.hasClass('recordGroup'), NeedToAdd: needToAdd },
          function (res) {
            if (res.Success) {
              if (needToAdd) {
                if (favoritesGroup.children('#' + itemId).length == 0) {
                  var clone = item.clone();
                  me._InitRecordsListEvents(clone, false);
                  me._InitRecordsListEvents(clone, true); // для инициализации событий у дочерних элементов
                  clone.appendTo(favoritesGroup);
                  if (clone.hasClass('recordGroup')) { // если группа, то свернем ее
                    me.HideRecordsGroup(clone.children('span'));
                    me.HideRecordsGroup(clone.find('.recordGroup > span'));
                  }
                  me.markUnmarkItemAsFavorite(itemId, needToAdd);
                  favoritesGroup.removeClass('emptyGroup');
                }
              }
              else {
                favoritesGroup.children('#' + itemId).remove();
                me.markUnmarkItemAsFavorite(itemId, needToAdd);
                // Если скрыта оргструктура (кроме избранного ничего не отображается) и в избранном ничего нет, то покажем сообщение,
                // что нужно пользоваться поиском
                if (favoritesGroup.length != 0 && favoritesGroup.children('div').length == 0) {
                  if (res.Warning == "orghidden") {
                    me.showGroupsListMessage(L("ADD_USER_TO_FAVORITES_WITH_RIGHT_CLICK"));
                  }
                  favoritesGroup.addClass('emptyGroup');
                }
              }
            }
          });
    },

    // Помечает или снимает отметку избранных пользователей или групп
    // isFavorite - признак пометить как избранное или нет
    markUnmarkItemAsFavorite: function (id, isFavorite) {
      if (id) {
        var me = this;
        // если айпад, то в recordsList добавляется див для скролла
        var favGroup = $.scrollActive ? me.recordsList.children().children('#0') : me.recordsList.children('#0');
        var item = favGroup.length > 0 ? favGroup.siblings().find('#' + id) : me.recordsList.find('#' + id);
        item = item.add(favGroup.siblings('#' + id));
        item = item.add(favGroup.children().find('#' + id));
        var icon = item.children('span').find('p.ico');
        var iconClass = me.treeModeRecordIconClass;
        if (isFavorite) {
          if (item.hasClass('item')) { // если это пользователь
            if (!item.hasClass('selected')) { // у выбранных записей иконки не меняем
              icon.removeClass(iconClass).addClass(me.favoriteUserIconClass);
            }
          } // если это группа
          else {
            icon.removeClass(me.treeModeGroupIconClass).addClass(me.favoriteUserGroupIconClass);
          }
          item.addClass('favorite');
        }
        else {
          if (item.hasClass('item')) { // если это пользователь
            if (!item.hasClass('selected')) { // у выбранных записей иконки не меняем
              icon.removeClass(me.favoriteUserIconClass).addClass(iconClass);
            }
          } // если это группа
          else {
            icon.removeClass(me.favoriteUserGroupIconClass).addClass(me.treeModeGroupIconClass);
          }
          item.removeClass('favorite');
        }
      }
    },

    /* ------------------------------------- */

    /* Действия с записями */

    //REVIEW Название не говорящее + Комментарий (что за курсор?)
    MoveCursor: function (down) {
      var me = this;
      if (me.recordsList) {
        var currentItem = me.recordsList.find('.item.over, .groupOver').first();
        if (currentItem.length) { // если уже есть выделенный элемент, то ищем следующий
          var obj = me.GetNextItemToSelect(currentItem, down);
          if (obj.NextItem.length) {
            if (currentItem.hasClass('item')) { // если текущее выделение было на элементе группы
              me.ScrollListToHoveredItem(currentItem, down);
              me.UnhoverItem(currentItem);
            }
            else { // если текущее выделение было на заголовке группы
              me.ScrollListToHoveredItem(currentItem.children(':first'), down);
              me.UnhoverGroup(currentItem);
            }
            // если следующий элемент - группа, то вызываем соотв-щий ховер
            obj.IsGroup ? me.HoverGroup(obj.NextItem) : me.HoverItem(obj.NextItem);
          }
        }
        else { // если в списке не было выделенного элемента
          var item;
          var isGroup = true;
          // при нажатии вниз выделяем заголовок первой группы
          if (down) {
            item = me.recordsList.find('.recordGroup:first');
            if (item.length == 0) { // если группу не нашли то выдеялем первый элемент
              item = me.recordsList.find('.item:visible:first');
              isGroup = false;
            }
          }
          else { // при нажатии вверх выделяем последний видимый элемент
            item = me.recordsList.find('.item:visible:last');
            isGroup = false;
            if (item.length == 0) { // если элемент не нашли, выделяем заголовок последней свернутой группы
              item = me.recordsList.find('.hiddengroup:last');
              isGroup = true;
            }
          }
          // если нажали вниз и нет выделенного элемента, то переходим к самому первому
          me.recordsList.scrollTop(down ? 0 : 1000000); //REVIEW зачем? - для перемещения скрола в конец или начало списка
          isGroup ? me.HoverGroup(item) : me.HoverItem(item);
        }
      }
    },

    upDownKeyNavigation: function (down) {
      var me = this;
      var currentItem = me.recordsList.find('div.item.over:visible,div.recordGroup.groupOver:visible');
      if (currentItem.length) {
        // от текущего элемента делаем поиск в 3-х направлениях: в дочерних элементах, в следующих элементах на уровень выше и в элементах того же уровня
        var nextItem;
        if (down) {
          nextItem = currentItem.find('.item:visible:first,.recordGroup:visible:first').first();
          if (nextItem.length == 0) { // если не нашли внизу
            nextItem = me.findSiblingOrParent(currentItem, down);
          }
          if (nextItem.html() == currentItem.parent().html()) {
            nextItem = currentItem;
          }
        }
        else {
          nextItem = me.findSiblingOrParent(currentItem, down);
        }
        if (nextItem.length) {
          currentItem.hasClass('item') ? me.UnhoverItem(currentItem) : me.UnhoverGroup(currentItem);
          nextItem.hasClass('item') ? me.HoverItem(nextItem) : me.HoverGroup(nextItem);
          me.scrollListToHoveredItem(nextItem, down);
        }
      }
      else {
        if (down) {
          var item = me.recordsList.find('.item:visible:first,.recordGroup:visible:first').first();
          item.hasClass('item') ? me.HoverItem(item) : me.HoverGroup(item);
          me.recordsList.scrollTop(0);
        }
        else {
          var item = me.recordsList.find('.item:visible:last,.recordGroup:visible:last').last();
          item.hasClass('item') ? me.HoverItem(item) : me.HoverGroup(item);
          me.recordsList.scrollTop(100000);
        }
      }
    },

    findSiblingOrParent: function (item, down) {
      var nextItem;
      if (down) {
        nextItem = item.next('div:visible:first'); // ищем след элемент на этом же уровне
        if (nextItem.length == 0) { // если не нашли
          if (!item.parent('#recordsList').length) { // и если родительский элемент это не все дерево, и значит есть куда подниматься выше
            nextItem = this.findSiblingOrParent(item.parents('div:visible:first'), down); // ищем сиблингов у родителя или его родителей
          }
          else {
            nextItem = item;
          }
        }
      }
      else { // движение вверх
        nextItem = item.prev('div:visible:first'); // ищем сперва сиблинга
        var sibling = true;
        if (nextItem.length == 0) { // если его не нашли и родительский элемент не само дерево, и значит есть куда подниматься выше
          if (!item.parent('#recordsList').length) {
            nextItem = item.parents('div:visible:first'); // то берем родителя
            sibling = false;
            if (nextItem.length == 0) { // если его не нашли, то пытаемся найти сиблинга родителя или его родителей
              nextItem = this.findSiblingOrParent(item.parents('div:visible:first'), down);
            }
          }
          else { // если родитель - это все дерево, то мы на крайнем элементе и никуда не двигаемся
            nextItem = item;
            sibling = false;
          }
        }
        if (sibling) { // если нашли сиблинга, то проверяем наличие дочерних узлов и переходим к ним
          var subItem = nextItem.find('.item:visible:last,.recordGroup:visible:last').last();
          if (subItem.length) {
            nextItem = subItem;
          }
        }
      }
      if (nextItem.length && !nextItem.hasClass('item') && !nextItem.hasClass('recordGroup')) {
        nextItem = item;
      }
      return nextItem;
    },

    scrollListToHoveredItem: function (item, down) {
      var me = this;
      if (me.getItemsListHeight() > me.recordsList.height()) {
        var itemHeight = 20;
        var height = 0;
        var currentID = item.attr('id');
        var items = me.recordsList.find('div.item:visible,div.recordGroup:visible');

        if (down) {
          for (var i = items.length - 1; i >= 0; i--) {
            if ($(items[i]).attr('id') == currentID) {
              height += (i + 1) * itemHeight;
              break;
            }
          }
          if (me.recordsList.height() - height < 50) {
            me.recordsList.scrollTop(me.recordsList.scrollTop() + itemHeight);
          }
        }
        else {
          for (var i = 0; i < items.length; i++) {
            if ($(items[i]).attr('id') == currentID) {
              height += (i + 1) * itemHeight;
              break;
            }
          }
          if (height - me.recordsList.scrollTop() < 50) {
            me.recordsList.scrollTop(me.recordsList.scrollTop() - itemHeight);
          }
        }
      }
    },

    getItemsListHeight: function () {
      var height = 0;
      var items = this.recordsList.children();
      for (var i = 0; i < items.length; i++) {
        height += $(items[i]).height();
      }
      return height;
    },

    // Получает следующий элемент для выделения при навигации стрелочками
    GetNextItemToSelect: function (currentItem, down) {
      var me = this;
      var nextItem;
      var isGroup = false;
      if (currentItem.hasClass('item')) {
        nextItem = down ? currentItem.next('.item:visible') : currentItem.prev('.item:visible');
        if (nextItem.length == 0) { // если не нашлись записи то переводим курсор на группу
          nextItem = down ? currentItem.parent('.recordGroup').next() : currentItem.parent('.recordGroup');
          isGroup = true;
        }
      }
      else {
        // здесь nextItem - это группа
        nextItem = down ? currentItem.children('.item:visible:first') : currentItem.prev().children('.item:visible:last');
        if (nextItem.length == 0) { // если не нашлись записи то переводим курсор на группу
          nextItem = down ? currentItem.next() : currentItem.prev();
          isGroup = true;
        }
      }
      return { NextItem: nextItem, IsGroup: isGroup };
    },

    ScrollListToHoveredItem: function (currentItem, down) {
      var me = this;
      if (down) {
        if (Math.abs(currentItem.position().top - me.recordsList.height()) < 55) { //REVIEW что за магические числа? - вычисленные экспериментальным путем
          var scroll = me.recordsList.scrollTop();
          me.recordsList.scrollTop(scroll + currentItem.height());
        }
      }
      else {
        if (Math.abs(currentItem.position().top) < 104) { //REVIEW что за магические числа?
          var scroll = me.recordsList.scrollTop();
          me.recordsList.scrollTop(scroll - currentItem.height());
        }
      }
    },

    RightArrowKeyPress: function () {
      var me = this;
      var title = me.recordsList.find('.groupOver');
      // пустые или группы со скрытой структурой не открываем
      if (title.length > 0 && !title.hasClass('emptyGroup')) {
        me.HoverGroup(title);
        me.ShowRecordsGroup(title.children(':first'));
      }
    },

    LeftArrowKeyPress: function () {
      var me = this;
      var title = me.recordsList.find('.item.over,.recordGroup.groupOver').parent(':not(#recordsList)');
      if (!title.length) { title = me.recordsList.find('.groupOver'); }
      if (title.length) {
        me.HoverGroup(title);
        me.HideRecordsGroup(title.children(':first'));
        me.ScrollListToHoveredItem(title.children(':first'), true);
      }
    },

    DeleteKeyPress: function () {
      var me = this;
      var idToRemove = me.recordsList.find('.item.over').attr('id');
      if (idToRemove) {
        var rowDeleteButton = me.selectedRecordsTable.find('tr[id=' + idToRemove + ']').find('.removeFromSelect');
        me.DeleteItemFromSelection(rowDeleteButton);
      }
    },

    ShowHideRecordsGroup: function (groupTitle) {
      groupTitle = $(groupTitle);
      var gr = groupTitle.parent();
      // Группы которые нельзя раскрывать, не расскрываем.
      if (!gr.hasClass('emptyGroup')) {
        if (groupTitle.parent().hasClass('hiddengroup')) {
          this.ShowRecordsGroup(groupTitle);
        }
        else {
          this.HideRecordsGroup(groupTitle);
        };
        this._InitScrollForTouchScreens();
      };
    },

    ShowRecordsGroup: function (groupTitle) {
      var me = this;
      groupTitle.parent().removeClass('hiddengroup');
      groupTitle.children().first().removeClass('closedgroup').addClass('openedgroup');
      if (me.treeMode) {
        if (groupTitle.siblings().length == 0) {
          groupTitle.parent().append($('<div class="waiting"><p class="processing"></p></div>'));
          me.requestTree(groupTitle.parent(), "");
        }
      } else {
        var grEl = groupTitle.parent();
        var groupcode = grEl.attr('compcode');
        var group = me.dataObject.groups[groupcode];
        // Загружаем, если еще не загружали.
        if (!group.isLoaded) {
          if (grEl.find('.waiting').length == 0) {
            grEl.append($('<div class="waiting"><p class="processing"></p></div>'));
          };
          me.sendRequest('', groupcode, function () {
            // Построим элементы группы.
            groupTitle.siblings('.waiting').remove();
            grEl.append(me.buildItemsList(groupcode, group));
            me._InitRecordsListEvents(grEl, true);
            me.MarkSelectedRecordsInList();
          }, function () {
            // Покажем сообщение об ошибке.
            groupTitle.siblings('.waiting').remove();
            grEl.append(me.buildItemsList(groupcode, group));
          });
        }
      };
    },

    HideRecordsGroup: function (groupTitle) {
      groupTitle.parent().addClass('hiddengroup');
      groupTitle.find('.openedgroup').removeClass('openedgroup').addClass('closedgroup');
    },

    MakeFilterRequest: function () {
      var me = this;;
      if (me.filterInput) {
        // Таймаут - что бы сократить количество обращений к серверу
        if (me._filterTimeout) clearTimeout(me._filterTimeout);
        me._filterTimeout = setTimeout(function () {
          var changedValue = me._CheckFilterValue();
          if (changedValue !== false) {
            me.getData(changedValue, function () {
              // Success
              me.fillItemsList();
              me._InitRecordsListEvents();
            });
          }
        }, 400);
      }
    },

    _CheckFilterValue: function () {
      var me = this;
      var currentValue;
      currentValue = $.trim(me.filterInput.val());
      var whiteSpaceCheck = currentValue.replace(/ /g, ""); // убираем все пробелы в строке из поля ввода для проверки на строку из пробелов.
      if (currentValue !== me.lastFilterValue) {
        if (whiteSpaceCheck !== "") {
          return currentValue;
        } else {
          return "";
        };
      } else {
        return false;
      };
    },

    SelectItem(item) {
      // Если только для чтения запрещаем выбирать.
      if (!this.rsInstance.isReadonly()) {
        const jItem = $(item);
        const id = jItem.attr('id');
        if (!id) {
          return ;
        }
        let groupCode;
        if (this.treeMode) {
          groupCode = jItem.data('groupcode');
        } else if (Object.keys(this.dataObject.groups).length > 1) {
          groupCode = jItem.parents('.recordGroup').first().attr('compcode');
        } else {
          groupCode = this.rsInstance.getFirstRefCode();
        }

        const name = item.find('> span div').text();

        // Получить элемент из списка
        const listItem = this.dataObject.groups[groupCode].items.find(el => el.id === id);
        const newItem = {
          groupcode: (!!listItem) ? listItem.refCode || groupCode : groupCode,
          id,
          name,
        };

        this._addItemCollectionToSelectedTable([newItem]);

        this.fire('OnSelectedItem', newItem);
      }
    },

    // Добавляет новые строки в таблицу выбранных и помечает галочкой в дереве.
    _addItemCollectionToSelectedTable: function (items) {
      var me = this;
      var html = "";
      for (var i = 0; i < items.length; i++) {
        if (me.findSelectedItemById(items[i].id) !== -1) continue;
        html += me.buildSelectedItemsTableRow(items[i]);
        me.dataObject.selectedItems.push(items[i]);
        me.MarkRecord(items[i].id, true);
      }
      if (html != "") {
        me.selectedRecordsTable.find('td.dataTables_empty').parent().remove();
        me.selectedRecordsTable.append(html);
        me.selectedRecordsTable.find('tr').each(function () { me._InitSingleSelectedRecordEvents(this); });
        me._fixSelectedItemsTableBorder();
        me.selectedRecordsTable.parent().scrollTop(1000000);
      }
    },

    // Заменяет добавленный элемент на другие.
    replaceSelectedItem: function (oldId, newItems) {
      var me = this, rs = me.rsInstance;
      // Если только для чтения, запрещаем заменять выбранные записи.
      if (!rs.isReadonly()) {
        // Удаляем элемент по ИД.
        me.DeleteItemFromSelection(me.selectedRecordsTable.find('tr[id="' + oldId.id + '"]').find('p.removeFromSelect'));
        // Добавляем новые элементы в таблицу.
        me._addItemCollectionToSelectedTable(newItems);
      }
    },

    DeleteItemFromSelection: function (item) {
      var me = this, rs = me.rsInstance;
      // Если только для чтения, запрещаем удалять выбранные записи.
      if (!rs.isReadonly()) {
        var row = $(item).parent().parent();
        var id = row.attr('id');

        var idx = me.findSelectedItemById(id);
        if (idx !== -1) {
          me.dataObject.selectedItems.splice(idx, 1);
        };

        row.remove();
        me.MarkRecord(id, false);
        me._fixSelectedItemsTableBorder();
        me.checkEmptyTable();
      }
    },

    HoverGroup: function (group) {
      this.UnhoverGroup(this.recordsList.find('.groupOver'));
      $(group).addClass('groupOver');
      this.UnhoverItem(this.recordsList.find('.over'));
    },

    UnhoverGroup: function (group) {
      $(group).removeClass('groupOver').addClass('fake');
    },

    HoverItem: function (item) {
      var me = this;
      me.UnhoverItem(this.recordsList.find('.over'));
      me.UnhoverGroup(this.recordsList.find('.groupOver'));
      $(item).addClass('over').find('.treeview_img_action').css('visibility', 'visible');
    },

    UnhoverItem: function (item) {
      $(item).removeClass('over').find('.treeview_img_action').css('visibility', 'hidden');
    },

    MarkSelectedRecordsInList: function () {
      var me = this,
          selItems = me.dataObject.selectedItems;
      for (var i = 0, len = selItems.length; i < len; i++) {
        me.MarkRecord(selItems[i].id, true);
      }
    },

    MarkRecord: function (id, mark) {
      if (id) {
        var item = this.recordsList.find('.item[id=' + id + '],.recordGroup[id=' + id + ']');
        var icon = item.find('p.ico');
        var isGroup = item.hasClass('recordGroup');
        var iconClass;
        var favoritesItem;
        if (this.treeMode) {
          favoritesItem = this.recordsList.find('#0').children('#' + id);
          if (item.hasClass('favorite')) { // если есть в избранных
            iconClass = isGroup ? this.favoriteUserGroupIconClass : this.favoriteUserIconClass;
          }
          else {
            iconClass = isGroup ? this.treeModeGroupIconClass : this.treeModeRecordIconClass;
          }
          //если группа избранное
          if (item.find('div[title="Favorites"]').length > 0) {
            iconClass = this.favoriteUserGroupIconClass;
          }
        }
        else {
          iconClass = this.defaultRecordIconClass;
        }
        var markedIconClass = this.treeMode ? (isGroup ? this.treeModeMarkedGroupIconClass : this.treeModeMarkedRecordIconClass) : this.defaultMarkedRecordIconClass;
        if (mark) {
          item.addClass('selected');
          if (this.treeMode) { icon.removeClass(this.treeModeRecordIconClass).removeClass(this.favoriteUserIconClass); }
          icon.removeClass(iconClass).addClass(markedIconClass);
        }
        else {
          item.removeClass('selected');
          icon.removeClass(markedIconClass).addClass(iconClass);
          // в группе избранное иконки со звездочкой заменяем на обычные. значение iconClass определяется выше в if(this.treeMode)
          if (this.treeMode) {
            favoritesItem.find('p.ico').removeClass(iconClass).addClass(isGroup ? this.treeModeGroupIconClass : this.treeModeRecordIconClass);
          }
        }
      }
    },

    // Добавлем бордер к div в которой находится таблица.
    _fixSelectedItemsTableBorder: function () {
      var me = this;
      var p = me.selectedRecordsTable.parent();
      if (me.selectedRecordsTable.height() > p.height()) {
        p.addClass('fixBorderBottom');
      } else {
        p.removeClass('fixBorderBottom');
      };
    },

    _adjustModalWindowIfSmallScreen: function () {
      var me = this;
      if ($(window).width() < 1000) {
        me.recordsList.parents('[role=dialog]').css('left', 50).css('top', 200);
        $(window).scrollLeft(0);
      }
    },

    _disableRefSelectInputIfAndroid: function () {
      if (WA.ENV.isAndroid()) {
        this.rsInstance.inp.attr('disabled', true);
        $('.fakeInput').attr('disabled', true);
      }
    },

    checkEmptyTable: function () {
      var rows = this.selectedRecordsTable.children('tbody').find('tr');
      if (rows.length == 0) {
        var emptyRow = $('<tr><td valign="top" colspan="3" class="dataTables_empty">' + L('EMPTY') + '</td></tr>');
        this.selectedRecordsTable.append(emptyRow);
        this._InitSingleSelectedRecordEvents(emptyRow);
      }
    }

  };

  $.fn.extend({
    MultiSelectModalWindow: function (opt) {
      this.data('MultiSelectModalWindowInstance', new MultiSelectModalWindow(this, opt));
      return this;
    },
    ShowMultiSelectModalWindow: function () {
      var ms = this.data('MultiSelectModalWindowInstance');
      if (ms) ms.show();
      return this;
    }
  });
})(jQuery);

// Оставлено для примера. не удалять!
//var data = {
//  groups:
//    {
//      length: 2,
//      'ПОЛ': {
//        groupname: "Пользователи",
//        isLoaded: true,
//        items: [
//        { id: "1", name: "Пупкин Андрей Борисович 1" },
//        { id: "2", name: "Пупкин Андрей Борисович 2" },
//        { id: "3", name: "Пупкин Андрей Борисович 3" }
//      ]
//      },
//      "ГПЛ": {
//        groupname: "Группы пользователей",
//        isLoaded: true,
//        items: [
//        { id: "100", name: "Группа 1" },
//        { id: "101", name: "Группа 2" },
//        { id: "102", name: "Группа 3"}//,
//        //{ groupname: "Бухгалтерия", compcode: "ПОЛ", items: [{ id: "1", name: "Пупкин Андрей Борисович 1" }, { id: "4", name: "Бухгалтер 1" }, { id: "5", name: "Бухгалтер 2"}] }
//      ]
//      }
//    },
//  selectedItems:
//    [
//      { groupcode: "ПОЛ", id: "111", name: "Пупкин Андрей Борисович" },
//      { groupcode: "ПОЛ", id: "112", name: "Иванов Иван Иванович" },
//      { groupcode: "ПОЛ", id: "113", name: "Петров Петр Петрович" }
//    ]
//};
